module.exports = __webpack_public_path__ + "static/media/rings.3c6335ac.jpg";